const tableData = [
  {
    "AnimalSpecies": null,
    "AnimalStrain": null,
    "Category": null,
    "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
    "CreatedDate": "2022-06-09T01:03:39.570Z",
    "Description": null,
    "EndDate": null,
    "ID": "21c63a0e-5a8d-4d02-8fea-19b2d07e50ec",
    "ModifiedByUserID": null,
    "ModifiedDate": "2022-06-09T01:03:39.570Z",
    "Name": "test",
    "Sponsor": null,
    "StartDate": null,
    "Status": null,
    "TestFacility": null,
    "AnimalGroups": [
      {
        "Administration": null,
        "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
        "CreatedDate": "2022-06-09 01:03:39.851128",
        "Dose": null,
        "ID": "2ea200cf-93bc-428d-a9e9-c6c16df2d0a6",
        "ModifiedByUserID": null,
        "ModifiedDate": "2022-06-09 01:03:39.851128",
        "Name": "Baz1a knockout",
        "SacrificePeriod": null,
        "StudyID": "21c63a0e-5a8d-4d02-8fea-19b2d07e50ec",
        "TreatmentTime": null,
        "TreatmentType": null,
        "Animals": [
          {
            "AnimalGroupID": "2ea200cf-93bc-428d-a9e9-c6c16df2d0a6",
            "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
            "CreatedDate": "2022-06-09 01:03:49.001496",
            "Description": null,
            "ID": "39bd7112-89f8-410a-92b5-435422b2645e",
            "ModifiedByUserID": null,
            "ModifiedDate": "2022-06-09 01:03:49.001496",
            "Name": "Baz1a-14-100",
            "ProcedureNotes": null,
            "Sex": "female",
            "Species": "Mus musculus(NCBITaxon_10090)",
            "Strain": "Baz1a knockout"
          },
          {
            "AnimalGroupID": "2ea200cf-93bc-428d-a9e9-c6c16df2d0a6",
            "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
            "CreatedDate": "2022-06-09 01:03:49.295823",
            "Description": null,
            "ID": "dbe58dfd-9992-427e-bfba-b9d59feb1b0e",
            "ModifiedByUserID": null,
            "ModifiedDate": "2022-06-09 01:03:49.295823",
            "Name": "Baz1a-14-75",
            "ProcedureNotes": null,
            "Sex": "male",
            "Species": "Mus musculus(NCBITaxon_10090)",
            "Strain": "Baz1a knockout"
          },
          {
            "AnimalGroupID": "2ea200cf-93bc-428d-a9e9-c6c16df2d0a6",
            "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
            "CreatedDate": "2022-06-09 01:03:49.590988",
            "Description": null,
            "ID": "3e1af2d6-1086-40c0-984a-3b5b46dbf94c",
            "ModifiedByUserID": null,
            "ModifiedDate": "2022-06-09 01:03:49.590988",
            "Name": "Baz1a-14-76",
            "ProcedureNotes": null,
            "Sex": "male",
            "Species": "Mus musculus(NCBITaxon_10090)",
            "Strain": "Baz1a knockout"
          },
          {
            "AnimalGroupID": "2ea200cf-93bc-428d-a9e9-c6c16df2d0a6",
            "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
            "CreatedDate": "2022-06-09 01:03:49.861465",
            "Description": null,
            "ID": "3921280f-ed11-4aca-a102-b2d94365be4d",
            "ModifiedByUserID": null,
            "ModifiedDate": "2022-06-09 01:03:49.861465",
            "Name": "Baz1a-14-99",
            "ProcedureNotes": null,
            "Sex": "female",
            "Species": "Mus musculus(NCBITaxon_10090)",
            "Strain": "Baz1a knockout"
          }
        ]
      },
      {
        "Administration": null,
        "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
        "CreatedDate": "2022-06-09 01:03:40.241611",
        "Dose": null,
        "ID": "30dbe5cd-6d3f-4ccc-9e5d-0f97648d7889",
        "ModifiedByUserID": null,
        "ModifiedDate": "2022-06-09 01:03:40.241611",
        "Name": "Ddx41 knockout",
        "SacrificePeriod": null,
        "StudyID": "21c63a0e-5a8d-4d02-8fea-19b2d07e50ec",
        "TreatmentTime": null,
        "TreatmentType": null,
        "Animals": [
          {
            "AnimalGroupID": "30dbe5cd-6d3f-4ccc-9e5d-0f97648d7889",
            "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
            "CreatedDate": "2022-06-09 01:03:50.229489",
            "Description": null,
            "ID": "6bd1ab8e-3a3c-416b-864a-f29e6c38c032",
            "ModifiedByUserID": null,
            "ModifiedDate": "2022-06-09 01:03:50.229489",
            "Name": "Ddx41-14-550",
            "ProcedureNotes": null,
            "Sex": "male",
            "Species": "Mus musculus(NCBITaxon_10090)",
            "Strain": "Ddx41 knockout"
          },
          {
            "AnimalGroupID": "30dbe5cd-6d3f-4ccc-9e5d-0f97648d7889",
            "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
            "CreatedDate": "2022-06-09 01:03:50.598269",
            "Description": null,
            "ID": "fa698fef-6f92-41e2-983c-29b9ae7ad302",
            "ModifiedByUserID": null,
            "ModifiedDate": "2022-06-09 01:03:50.598269",
            "Name": "Ddx41-14-552",
            "ProcedureNotes": null,
            "Sex": "male",
            "Species": "Mus musculus(NCBITaxon_10090)",
            "Strain": "Ddx41 knockout"
          },
          {
            "AnimalGroupID": "30dbe5cd-6d3f-4ccc-9e5d-0f97648d7889",
            "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
            "CreatedDate": "2022-06-09 01:03:50.884953",
            "Description": null,
            "ID": "7e07fdcf-f53d-45e5-88f2-4aadd41d985e",
            "ModifiedByUserID": null,
            "ModifiedDate": "2022-06-09 01:03:50.884953",
            "Name": "Ddx41-14-566",
            "ProcedureNotes": null,
            "Sex": "female",
            "Species": "Mus musculus(NCBITaxon_10090)",
            "Strain": "Ddx41 knockout"
          },
          {
            "AnimalGroupID": "30dbe5cd-6d3f-4ccc-9e5d-0f97648d7889",
            "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
            "CreatedDate": "2022-06-09 01:03:51.181605",
            "Description": null,
            "ID": "9cb1be71-abc6-475b-9f32-5cdfa03c3250",
            "ModifiedByUserID": null,
            "ModifiedDate": "2022-06-09 01:03:51.181605",
            "Name": "Ddx41-14-579",
            "ProcedureNotes": null,
            "Sex": "female",
            "Species": "Mus musculus(NCBITaxon_10090)",
            "Strain": "Ddx41 knockout"
          },
          {
            "AnimalGroupID": "30dbe5cd-6d3f-4ccc-9e5d-0f97648d7889",
            "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
            "CreatedDate": "2022-06-09 01:03:51.469888",
            "Description": null,
            "ID": "ca72d7d8-ada2-4efd-ba57-3b26e44cb743",
            "ModifiedByUserID": null,
            "ModifiedDate": "2022-06-09 01:03:51.469888",
            "Name": "Ddx41-14-582",
            "ProcedureNotes": null,
            "Sex": "female",
            "Species": "Mus musculus(NCBITaxon_10090)",
            "Strain": "Ddx41 knockout"
          }
        ]
      },
      {
        "Administration": null,
        "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
        "CreatedDate": "2022-06-09 01:03:40.627923",
        "Dose": null,
        "ID": "21f8ddcb-8547-42a0-a4c6-0e397ed7b283",
        "ModifiedByUserID": null,
        "ModifiedDate": "2022-06-09 01:03:40.627923",
        "Name": "Eya4 knockout",
        "SacrificePeriod": null,
        "StudyID": "21c63a0e-5a8d-4d02-8fea-19b2d07e50ec",
        "TreatmentTime": null,
        "TreatmentType": null,
        "Animals": [
          {
            "AnimalGroupID": "21f8ddcb-8547-42a0-a4c6-0e397ed7b283",
            "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
            "CreatedDate": "2022-06-09 01:03:51.755493",
            "Description": null,
            "ID": "ffaed1ea-e9f4-4813-a4c4-c50adcebf433",
            "ModifiedByUserID": null,
            "ModifiedDate": "2022-06-09 01:03:51.755493",
            "Name": "Eya4-14-431",
            "ProcedureNotes": null,
            "Sex": "male",
            "Species": "Mus musculus(NCBITaxon_10090)",
            "Strain": "Eya4 knockout"
          },
          {
            "AnimalGroupID": "21f8ddcb-8547-42a0-a4c6-0e397ed7b283",
            "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
            "CreatedDate": "2022-06-09 01:03:52.149348",
            "Description": null,
            "ID": "6da2e079-bd92-4be8-914a-36c1b30f1c3b",
            "ModifiedByUserID": null,
            "ModifiedDate": "2022-06-09 01:03:52.149348",
            "Name": "Eya4-14-432",
            "ProcedureNotes": null,
            "Sex": "male",
            "Species": "Mus musculus(NCBITaxon_10090)",
            "Strain": "Eya4 knockout"
          },
          {
            "AnimalGroupID": "21f8ddcb-8547-42a0-a4c6-0e397ed7b283",
            "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
            "CreatedDate": "2022-06-09 01:03:52.525719",
            "Description": null,
            "ID": "f652a2a1-3604-457c-b940-72b5974c490f",
            "ModifiedByUserID": null,
            "ModifiedDate": "2022-06-09 01:03:52.525719",
            "Name": "Eya4-14-433",
            "ProcedureNotes": null,
            "Sex": "male",
            "Species": "Mus musculus(NCBITaxon_10090)",
            "Strain": "Eya4 knockout"
          },
          {
            "AnimalGroupID": "21f8ddcb-8547-42a0-a4c6-0e397ed7b283",
            "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
            "CreatedDate": "2022-06-09 01:03:52.81902",
            "Description": null,
            "ID": "dd832779-3532-4067-8ff5-de47fbdf5f76",
            "ModifiedByUserID": null,
            "ModifiedDate": "2022-06-09 01:03:52.81902",
            "Name": "Eya4-14-434",
            "ProcedureNotes": null,
            "Sex": "female",
            "Species": "Mus musculus(NCBITaxon_10090)",
            "Strain": "Eya4 knockout"
          },
          {
            "AnimalGroupID": "21f8ddcb-8547-42a0-a4c6-0e397ed7b283",
            "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
            "CreatedDate": "2022-06-09 01:03:53.18798",
            "Description": null,
            "ID": "e72b9122-441a-440f-bde1-7ab7413ae766",
            "ModifiedByUserID": null,
            "ModifiedDate": "2022-06-09 01:03:53.18798",
            "Name": "Eya4-14-435",
            "ProcedureNotes": null,
            "Sex": "female",
            "Species": "Mus musculus(NCBITaxon_10090)",
            "Strain": "Eya4 knockout"
          },
          {
            "AnimalGroupID": "21f8ddcb-8547-42a0-a4c6-0e397ed7b283",
            "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
            "CreatedDate": "2022-06-09 01:03:53.498099",
            "Description": null,
            "ID": "af3bbc56-e2aa-4611-a5fc-9e7596030371",
            "ModifiedByUserID": null,
            "ModifiedDate": "2022-06-09 01:03:53.498099",
            "Name": "Eya4-14-436",
            "ProcedureNotes": null,
            "Sex": "female",
            "Species": "Mus musculus(NCBITaxon_10090)",
            "Strain": "Eya4 knockout"
          }
        ]
      },
      {
        "Administration": null,
        "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
        "CreatedDate": "2022-06-09 01:03:41.089997",
        "Dose": null,
        "ID": "03fc4634-7af5-4e45-b546-e129418a751a",
        "ModifiedByUserID": null,
        "ModifiedDate": "2022-06-09 01:03:41.089997",
        "Name": "Idh1 knockout",
        "SacrificePeriod": null,
        "StudyID": "21c63a0e-5a8d-4d02-8fea-19b2d07e50ec",
        "TreatmentTime": null,
        "TreatmentType": null,
        "Animals": [
          {
            "AnimalGroupID": "03fc4634-7af5-4e45-b546-e129418a751a",
            "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
            "CreatedDate": "2022-06-09 01:03:53.815449",
            "Description": null,
            "ID": "8a5212fc-b7f1-4e4c-adc6-284a0e2bec01",
            "ModifiedByUserID": null,
            "ModifiedDate": "2022-06-09 01:03:53.815449",
            "Name": "Idh1-14-177",
            "ProcedureNotes": null,
            "Sex": "male",
            "Species": "Mus musculus(NCBITaxon_10090)",
            "Strain": "Idh1 knockout"
          },
          {
            "AnimalGroupID": "03fc4634-7af5-4e45-b546-e129418a751a",
            "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
            "CreatedDate": "2022-06-09 01:03:54.136053",
            "Description": null,
            "ID": "e805055b-da86-4f83-a813-680788156260",
            "ModifiedByUserID": null,
            "ModifiedDate": "2022-06-09 01:03:54.136053",
            "Name": "Idh1-14-178",
            "ProcedureNotes": null,
            "Sex": "female",
            "Species": "Mus musculus(NCBITaxon_10090)",
            "Strain": "Idh1 knockout"
          },
          {
            "AnimalGroupID": "03fc4634-7af5-4e45-b546-e129418a751a",
            "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
            "CreatedDate": "2022-06-09 01:03:54.750338",
            "Description": null,
            "ID": "d0b7d201-e455-4822-94e1-c3e4387ac03a",
            "ModifiedByUserID": null,
            "ModifiedDate": "2022-06-09 01:03:54.750338",
            "Name": "Idh1-14-182",
            "ProcedureNotes": null,
            "Sex": "male",
            "Species": "Mus musculus(NCBITaxon_10090)",
            "Strain": "Idh1 knockout"
          },
          {
            "AnimalGroupID": "03fc4634-7af5-4e45-b546-e129418a751a",
            "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
            "CreatedDate": "2022-06-09 01:03:55.024994",
            "Description": null,
            "ID": "e6aca407-50dc-45a1-a3fc-5ddc1bf995a7",
            "ModifiedByUserID": null,
            "ModifiedDate": "2022-06-09 01:03:55.024994",
            "Name": "Idh1-14-183",
            "ProcedureNotes": null,
            "Sex": "female",
            "Species": "Mus musculus(NCBITaxon_10090)",
            "Strain": "Idh1 knockout"
          }
        ]
      },
      {
        "Administration": null,
        "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
        "CreatedDate": "2022-06-09 01:03:41.366405",
        "Dose": null,
        "ID": "6b0dcfc8-e02f-426a-a181-b5ced04c5d54",
        "ModifiedByUserID": null,
        "ModifiedDate": "2022-06-09 01:03:41.366405",
        "Name": "Pipox knockout",
        "SacrificePeriod": null,
        "StudyID": "21c63a0e-5a8d-4d02-8fea-19b2d07e50ec",
        "TreatmentTime": null,
        "TreatmentType": null,
        "Animals": [
          {
            "AnimalGroupID": "6b0dcfc8-e02f-426a-a181-b5ced04c5d54",
            "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
            "CreatedDate": "2022-06-09 01:03:55.301737",
            "Description": null,
            "ID": "19ee4731-8da4-4101-b563-0706994d7aea",
            "ModifiedByUserID": null,
            "ModifiedDate": "2022-06-09 01:03:55.301737",
            "Name": "Pipox-14-209",
            "ProcedureNotes": null,
            "Sex": "female",
            "Species": "Mus musculus(NCBITaxon_10090)",
            "Strain": "Pipox knockout"
          },
          {
            "AnimalGroupID": "6b0dcfc8-e02f-426a-a181-b5ced04c5d54",
            "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
            "CreatedDate": "2022-06-09 01:03:55.580544",
            "Description": null,
            "ID": "376fa184-9ba1-4fc8-97f5-44110a5fc3e3",
            "ModifiedByUserID": null,
            "ModifiedDate": "2022-06-09 01:03:55.580544",
            "Name": "Pipox-14-210",
            "ProcedureNotes": null,
            "Sex": "male",
            "Species": "Mus musculus(NCBITaxon_10090)",
            "Strain": "Pipox knockout"
          },
          {
            "AnimalGroupID": "6b0dcfc8-e02f-426a-a181-b5ced04c5d54",
            "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
            "CreatedDate": "2022-06-09 01:03:55.860555",
            "Description": null,
            "ID": "70770f69-077a-44c7-9bbd-0e05092f7524",
            "ModifiedByUserID": null,
            "ModifiedDate": "2022-06-09 01:03:55.860555",
            "Name": "Pipox-14-211",
            "ProcedureNotes": null,
            "Sex": "female",
            "Species": "Mus musculus(NCBITaxon_10090)",
            "Strain": "Pipox knockout"
          },
          {
            "AnimalGroupID": "6b0dcfc8-e02f-426a-a181-b5ced04c5d54",
            "CreatedByUserID": "5270a192-2862-49d7-b08a-1c74b898d1b1",
            "CreatedDate": "2022-06-09 01:03:56.202106",
            "Description": null,
            "ID": "94bc6e2e-5e51-4599-9a5e-a9fcb14a36a0",
            "ModifiedByUserID": null,
            "ModifiedDate": "2022-06-09 01:03:56.202106",
            "Name": "Pipox-14-291",
            "ProcedureNotes": null,
            "Sex": "male",
            "Species": "Mus musculus(NCBITaxon_10090)",
            "Strain": "Pipox knockout"
          }
        ]
      }
    ],
    "Organs": [
      {
        "CreatedByUserID": "5737c6b6-729b-4f27-86e2-ec039cbc8732",
        "CreatedDate": "2022-06-09 01:03:41.730976",
        "ID": "5c845e5f-0d33-4350-96ed-885b84d8aaff",
        "ModifiedByUserID": null,
        "ModifiedDate": "2022-06-09 01:03:41.730976",
        "Organ": "lymph node",
        "System": null
      },
      {
        "CreatedByUserID": "5737c6b6-729b-4f27-86e2-ec039cbc8732",
        "CreatedDate": "2022-06-09 01:03:42.039854",
        "ID": "2b7eba7d-1791-45c5-b302-42eed4f7a853",
        "ModifiedByUserID": null,
        "ModifiedDate": "2022-06-09 01:03:42.039854",
        "Organ": "salivary gland",
        "System": null
      },
      {
        "CreatedByUserID": "5737c6b6-729b-4f27-86e2-ec039cbc8732",
        "CreatedDate": "2022-06-09 01:03:42.472922",
        "ID": "8e21856f-9e74-412d-82c8-f907e31bfec1",
        "ModifiedByUserID": null,
        "ModifiedDate": "2022-06-09 01:03:42.472922",
        "Organ": "brain",
        "System": null
      },
      {
        "CreatedByUserID": "5737c6b6-729b-4f27-86e2-ec039cbc8732",
        "CreatedDate": "2022-06-09 01:03:42.834412",
        "ID": "5af2c4c8-453f-4a87-b6b5-fe19c19d9832",
        "ModifiedByUserID": null,
        "ModifiedDate": "2022-06-09 01:03:42.834412",
        "Organ": "eye",
        "System": null
      },
      {
        "CreatedByUserID": "5737c6b6-729b-4f27-86e2-ec039cbc8732",
        "CreatedDate": "2022-06-09 01:03:43.091944",
        "ID": "df996a35-40af-4549-894e-1f9fe1c86a0a",
        "ModifiedByUserID": null,
        "ModifiedDate": "2022-06-09 01:03:43.091944",
        "Organ": "gastrointestinal system",
        "System": null
      },
      {
        "CreatedByUserID": "5737c6b6-729b-4f27-86e2-ec039cbc8732",
        "CreatedDate": "2022-06-09 01:03:43.36883",
        "ID": "54bb3e68-b783-43ff-a7f2-3540ff21b982",
        "ModifiedByUserID": null,
        "ModifiedDate": "2022-06-09 01:03:43.36883",
        "Organ": "heart",
        "System": null
      },
      {
        "CreatedByUserID": "5737c6b6-729b-4f27-86e2-ec039cbc8732",
        "CreatedDate": "2022-06-09 01:03:43.720124",
        "ID": "f45a4a0b-8d64-4e54-a469-85c735ba58b9",
        "ModifiedByUserID": null,
        "ModifiedDate": "2022-06-09 01:03:43.720124",
        "Organ": "knee",
        "System": null
      },
      {
        "CreatedByUserID": "5737c6b6-729b-4f27-86e2-ec039cbc8732",
        "CreatedDate": "2022-06-09 01:03:44.041091",
        "ID": "6a85f985-3fd5-4f37-aa58-5014fd7398da",
        "ModifiedByUserID": null,
        "ModifiedDate": "2022-06-09 01:03:44.041091",
        "Organ": "liver",
        "System": null
      },
      {
        "CreatedByUserID": "5737c6b6-729b-4f27-86e2-ec039cbc8732",
        "CreatedDate": "2022-06-09 01:03:44.319446",
        "ID": "aba493c6-7b6c-4992-b791-7c8714761b33",
        "ModifiedByUserID": null,
        "ModifiedDate": "2022-06-09 01:03:44.319446",
        "Organ": "reproductive system",
        "System": null
      },
      {
        "CreatedByUserID": "5737c6b6-729b-4f27-86e2-ec039cbc8732",
        "CreatedDate": "2022-06-09 01:03:44.873017",
        "ID": "64f32e28-9cf2-4188-a670-7fb751426efd",
        "ModifiedByUserID": null,
        "ModifiedDate": "2022-06-09 01:03:44.873017",
        "Organ": "skin",
        "System": null
      }
    ]
  }
];

export default tableData;